import { useEffect, useState } from "react";
import Sidebar from "../../components/common/Sidebar";
import Navbar from "../../components/common/Navbar";
import {
  getStaffApi,
  updateStaffPasswordApi,
} from "../../services/authApi";

const StaffPasswordManagement = () => {
  const [staffList, setStaffList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [newPassword, setNewPassword] = useState("");

  // LOAD STAFF
  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const res = await getStaffApi();
        setStaffList(res.data);
      } catch (err) {
        alert("Failed to load staff");
      }
    };

    fetchStaff();
  }, []);

  // UPDATE PASSWORD
  const handleUpdatePassword = async () => {
    try {
      await updateStaffPasswordApi(selectedUser.id, {
        newPassword,
      });

      alert("✅ Password updated");

      setSelectedUser(null);
      setNewPassword("");
    } catch (err) {
      alert(err?.response?.data?.message || "Error");
    }
  };

  return (
    <div className="admin-container">
      <Sidebar role="admin" />

      <div className="admin-main">
        <Navbar />

        <div className="admin-content">
          <h2>🔐 Staff Password Management</h2>

          {/* STAFF TABLE */}
          <table className="staff-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {staffList.map((user) => (
                <tr key={user.id}>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>
                    {user.is_active ? "🟢 Active" : "🔴 Inactive"}
                  </td>
                  <td>
                    <button onClick={() => setSelectedUser(user)}>
                      Update Password
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* UPDATE PASSWORD BOX */}
          {selectedUser && (
            <div style={{ marginTop: "20px" }}>
              <h3>
                Update Password for {selectedUser.name}
              </h3>

              <input
                type="password"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) =>
                  setNewPassword(e.target.value)
                }
              />

              <button onClick={handleUpdatePassword}>
                Update
              </button>

              <button onClick={() => setSelectedUser(null)}>
                Cancel
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StaffPasswordManagement;